/* eslint-disable default-param-last, @typescript-eslint/default-param-last */
import { FIELD_CHANGE, SAVE_STEP, RECOVER_FORM } from '../actions/index'

const initialState = {
  step0: {
    email: '',
    tel: '',
  },
  step1: {
    juridicForm: '0',
    socialDenomination: '',
    isTransfer: 'false',
    siren: '',
    expeditionAddress: null,
    nbEmployees: 'null',
  },
  step2: {
    addressId: '-1',
    selectedIntervalOnAddressStep: 'year',
  },
  step3: {
    expeditionFrequency: 'scan_recyclage',
  },
  step3Partners: {
    qontoSelected: true,
    dougsSelected: true,
    caarlSelected: true,
    dircutSelected: true,
  },
  // étape « Votre activité » (site internet surprise, cf. specs/user-generated-sites/site-internet-surprise-duda.md)
  step3Activity: {
    description: '',
    commercialBrand: '',
    serviceArea: 'local',
    inputMode: 'text',
    skipped: false,
  },
  step5: {
    email: '',
    password: '',
    pwdconfirm: '',
  },
  mandataire: {
    type: null,
    particulier_name: '',
    birthplace: '',
    birthdate: '',
    phone_number: '',
    representant_name: '',
    siren: '',
    social_denomination: '',
    juridic_form: '0',
    id_justif_file: null,
    mandate_file: null,
    kbis_file: null,
  },
  representant: {
    gender: '0',
    firstname: '',
    name: '',
    qualite: '0',
    address: '',
    address2: '',
    cp: '',
    city: '',
    country: 'FR',
    tel: '',
    email: '',
  },
  userId: null,
  netheosToken: null,
  subscriptionToken: null,
}

function makeid() {
  let text = ''
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  for (let i = 0; i < 5; i += 1) {
    text += possible.charAt(
      Math.floor(
        Math.random() * possible.length,
      ),
    )
  }

  return text
}

// test values, to prefill subscription form replace "state = initialState" by this one
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const initialStateTest = {
  step0: {
    email: `cedric+${makeid()}@ma-domiciliation.fr`,
    tel: '0612312319',
  },
  step1: {
    juridicForm: 'SAS',
    // juridicForm: 'EI',
    socialDenomination: `Test ${makeid()}`,
    isTransfer: 'false',
    siren: '',
    expeditionAddress: {
      premise: 'premise',
      street: '5, allée des dahlias',
      cp: '12345',
      city: 'Lille',
      country: 'country',
    },
    nbEmployees: '1 - 9',
    // siren: '524671260',
  },
  step2: {
    addressId: '-1',
    selectedIntervalOnAddressStep: 'year',
  },
  step3: {
    expeditionFrequency: 'scan_recyclage',
  },
  step3Partners: {
    qontoSelected: false,
    dougsSelected: false,
    caarlSelected: true,
    dircutSelected: true,
  },
  representant: {
    gender: 'MR',
    firstname: 'pierre',
    name: 'gochgarian',
    qualite: 'gérant',
    address: '12 rue de belzunce  ',
    address2: '',
    cp: '75010',
    city: 'Paris',
    country: 'FR',
    tel: '0621661799',
    email: 'cedric@ma-domiciliation.fr',
  },
  mandataire: {
    type: null,
    particulier_name: '',
    birthplace: '',
    birthdate: '',
    phone_number: '',
    representant_name: '',
    siren: '',
    social_denomination: '',
    juridic_form: '0',
    id_justif_file: null,
    mandate_file: null,
    kbis_file: null,
  },
  step6: {
    email: '',
    password: 'test',
    pwdconfirm: 'test',
  },
  step7: {
    hasExpert: true,
    expertName: '',
    expertAddress: '',
  },
  userId: null,
  netheosToken: null,
}


const subscription = (state = initialState, action: ReduxAction) => {
  switch (action.type) {
    case FIELD_CHANGE: {
      const { step, field, value } = action

      return {
        ...state,
        [step]: {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          ...(state as any)[step],
          [field]: value,
        },
      }
    }

    case SAVE_STEP: {
      const { step, values } = action

      return {
        ...state,
        [step]: values,
      }
    }

    case RECOVER_FORM: {
      return action.forms
    }

    default:
      return state
  }
}

export default subscription
